'use client'

import { useRef, useState } from 'react'
import { PARTNER_PATHS } from '@/data/consulting-partner'

export default function PartnerCompiler() {
  const [active, setActive] = useState(0)
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([])

  const focusTab = (index: number) => {
    setActive(index)
    tabRefs.current[index]?.focus()
  }

  const onTabKeyDown = (
    event: React.KeyboardEvent<HTMLButtonElement>,
    index: number
  ) => {
    const last = PARTNER_PATHS.length - 1
    let next: number | null = null

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = (index + 1) % PARTNER_PATHS.length
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = (index + last) % PARTNER_PATHS.length
    } else if (event.key === 'Home') {
      next = 0
    } else if (event.key === 'End') {
      next = last
    }

    if (next === null) return
    event.preventDefault()
    focusTab(next)
  }

  return (
    <div className='cns-compiler' data-path={PARTNER_PATHS[active].id}>
      <div className='cns-instrument-bar'>
        <span>PM / Partner relay</span>
        <span>Partner in front / Pixelmojo backstage</span>
      </div>

      <div
        className='cns-compiler-tabs'
        role='tablist'
        aria-label='Choose a partner delivery path'
      >
        {PARTNER_PATHS.map((path, index) => (
          <button
            key={path.id}
            ref={element => {
              tabRefs.current[index] = element
            }}
            className='cns-compiler-tab'
            data-path={path.id}
            id={`partner-tab-${path.id}`}
            type='button'
            role='tab'
            aria-selected={index === active}
            aria-controls={`partner-panel-${path.id}`}
            aria-label={`${path.index}. ${path.title}`}
            tabIndex={index === active ? 0 : -1}
            onClick={() => setActive(index)}
            onKeyDown={event => onTabKeyDown(event, index)}
          >
            <span>{path.index}</span>
            {path.tab}
          </button>
        ))}
      </div>

      {PARTNER_PATHS.map((path, index) => (
        <section
          key={path.id}
          className='cns-compiler-panel'
          data-path={path.id}
          id={`partner-panel-${path.id}`}
          role='tabpanel'
          aria-labelledby={`partner-tab-${path.id}`}
          tabIndex={0}
          hidden={index !== active}
        >
          <div className='cns-relay-map'>
            <div className='cns-relay-cell cns-relay-brief'>
              <span className='cns-relay-kicker'>01 / Partner frontstage</span>
              <strong>Brief and client relationship</strong>
              <span className='cns-relay-subhead'>Inputs</span>
              <ul aria-label='Partner inputs'>
                {path.inputs.map(input => (
                  <li key={input}>{input}</li>
                ))}
              </ul>
            </div>

            <div className='cns-relay-cell cns-relay-work'>
              <span className='cns-relay-kicker'>
                02 / Pixelmojo backstage / Path {path.index}
              </span>
              <strong>{path.title}</strong>
              <p className='cns-relay-summary'>{path.summary}</p>
              <div className='cns-relay-constraint'>
                <span className='cns-relay-subhead'>Constraint</span>
                <p>{path.question}</p>
              </div>
              <div className='cns-relay-checks'>
                <span className='cns-relay-subhead'>Checks</span>
                <ul aria-label='Pixelmojo delivery checks'>
                  {path.checks.map(check => (
                    <li key={check}>{check}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className='cns-relay-cell cns-relay-signal'>
              <span>Approval relay</span>
              <strong>Partner stays in front</strong>
              <p>Brief in. Branded handoff out.</p>
            </div>

            <div className='cns-relay-cell cns-relay-handoff'>
              <span className='cns-relay-kicker'>03 / Partner handoff</span>
              <strong>{path.output}</strong>
              <p>{path.outcome}</p>
            </div>
          </div>
        </section>
      ))}
    </div>
  )
}
